import { BasicLayout, OrientationMap, Orientor } from '@1x2network/layout'
import { ContainerSpecification, ScalingText, ScalingTextSpecification } from '@1x2network/pixi_assets'
import { Page } from '@1x2network/pixi_splash'
import { CollectorAnimationLoop } from './splashLoops/CollectorAnimationLoop'
import { HoldAndWinLoop } from './splashLoops/HoldAndWinLoop'

/**
 * A single page in the splash screen. Crazy Tiki only has 1 page, so this is all of the splash contents.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class SplashPage extends Page<SplashPageSpec> {
    private layout: BasicLayout

    private hawText: Orientor<ScalingText>
    private collectorText: Orientor<ScalingText>

    constructor(options: { spec: SplashPageSpec; layout: BasicLayout }) {
        super({ spec: options.spec })

        this.layout = options.layout
        const spec = this.specification.sections
        const counterTexts = new Orientor({
            layout: this.layout,
            spec: spec.haw.text,
            create: (spec: ScalingTextSpecification) => new ScalingText({ spec, parent: this }),
            onOrient: (active, inactive) => {
                active.visible = true
                inactive.visible = false
            },
        })

        this.hawText = new Orientor({
            layout: this.layout,
            spec: spec.collector.text,
            create: (spec: ScalingTextSpecification) => new ScalingText({ spec, parent: this }),
            onOrient: (active, inactive) => {
                active.visible = true
                inactive.visible = false
            },
        })

        this.collectorText = counterTexts

        this.addComponents(
            new CollectorAnimationLoop({ parent: this, layout: this.layout }),
            new HoldAndWinLoop({ parent: this, layout: this.layout }),
        )
    }
}

export interface SplashPageSpec extends ContainerSpecification {
    sections: {
        haw: {
            text: OrientationMap<ScalingTextSpecification>
        }
        collector: {
            text: OrientationMap<ScalingTextSpecification>
        }
    }
}
